export const concernsTranslation: { [key: string]: string }[] = [
  {
    en: 'Dark Circles',
    hi: 'काले घेरे',
    mr: 'काळी वर्तुळे',
    te: 'నల్లటి వలయాలు',
    kn: 'ಡಾರ್ಕ್ ಸರ್ಕಲ್ಸ್',
    ta: 'கரு வளையங்கள்',
    bn: 'ডার্ক সার্কেল',
    ml: 'കറുത്ത വളയങ്ങൾ',
  },
  {
    en: 'Acne Scars',
    hi: 'एक्ने के निशान',
    mr: 'मुरुमांचे चट्टे',
    te: 'మొటిమల మచ్చలు',
    kn: 'ಏಕ್ನೆ ಸ್ಕಾರ್ಸ್',
    ta: 'முகப்பரு வடுக்கள்',
    bn: 'ব্রণর দাগ',
    ml: 'മുഖക്കുരുവിന്റെ പാടുകൾ',
  },
  {
    en: 'Inflammatory Acne',
    hi: 'इंफ्लेमेटरी एक्ने',
    mr: 'इंफ्लेमेटरी एक्ने',
    te: 'ఇన్ఫ్లమేటరీ యాక్నే',
    kn: 'ಇಂಪ್ಲಾಮೇಟರಿ ಏಕ್ನೆ',
    ta: 'இன்ஃப்ளமேட்டரி அக்னே',
    bn: null,
    ml: null,
  },
  {
    en: 'Anti Aging',
    hi: 'झुर्रियाँ',
    mr: 'सुरकुत्या',
    te: 'ముడతలు',
    kn: 'ರಿಂಕಲ್ಸ್',
    ta: 'சுருக்கங்கள்',
    bn: 'বলিরেখা',
    ml: 'പ്ചുളിവുകൾ',
  },
  {
    en: 'Dull skin',
    hi: 'सुस्त बेजान त्वचा',
    mr: 'निस्तेज त्वचा',
    te: 'నిస్తేజమైన చర్మం',
    kn: 'ಡಲ್ ಸ್ಕಿನ್',
    ta: 'பொலிவற்ற சருமம்',
    bn: 'নিস্তেজ প্রাণহীন ত্বক',
    ml: 'മങ്ങിയ ചർമ്മം',
  },
  {
    en: 'Comedones',
    hi: 'कॉमेडोन',
    mr: 'कॉमेडोन',
    te: 'కామెడోన్స్',
    kn: 'ಕಾಮೆಡೋನ್ಸ್',
    ta: 'கொமெடோன்கள்',
    bn: null,
    ml: null,
  },
  {
    en: 'Pigmentation',
    hi: 'पिगमेंटेशन',
    mr: 'पिगमेंटेशन',
    te: 'పిగ్మెంటేషన్',
    kn: 'ಪಿಗ್ಮೆಂಟೇಶನ್',
    ta: 'பிக்மென்டேஷன்',
    bn: null,
    ml: null,
  },
  {
    en: 'Acne',
    hi: 'एक्ने',
    mr: 'एक्ने',
    te: 'యాక్నే',
    kn: 'ಏಕ್ನೆ',
    ta: 'அக்னே',
    bn: null,
    ml: null,
  },
  {
    en: 'Melasma',
    hi: 'मेलास्मा',
    mr: 'मेलास्मा',
    te: 'మెలస్మా',
    kn: 'ಮೆಲಸ್ಮಾ',
    ta: 'மெலஸ்மா',
    bn: null,
    ml: null,
  },
  {
    en: 'Dark Spots',
    hi: 'डार्क स्पॉट्स',
    mr: 'डार्क स्पॉट्स',
    te: 'డార్క్ స్పాట్స్',
    kn: 'ಡಾರ್ಕ್ಸ್ ಸ್ಪಾಟ್ಸ್',
    ta: 'கரும்புள்ளிகள்',
    bn: null,
    ml: null,
  },
  {
    en: 'Open Pores',
    hi: 'ओपन पोर्स',
    mr: 'ओपन पोर्स',
    te: 'ఓపెన్ పోర్స్',
    kn: 'ಓಪನ್ ಪೋರ್ಸ್',
    ta: 'திறந்த சரும துளைகள்',
    bn: 'ওপেন পোর',
    ml: 'തുറന്ന സുഷിരങ്ങൾ',
  },
  {
    en: 'Temple baldness',
    hi: 'माथे के किनारों का गंजापन',
    mr: 'मस्तकाच्या बाजूचे टक्कल',
    te: 'నుదుటి పక్కల బట్టతల',
    kn: 'ಹಣೆಯ ಪಕ್ಕದ ಬೋಳುತನ',
    ta: 'நெற்றியின் பக்கங்களில் வழுக்கை',
    bn: 'কপালের পাশের টাক',
    ml: 'നെറ്റിയുടെ വശങ്ങളിലെ കഷണ്ടി',
  },
  {
    en: 'Other Scars',
    hi: 'अन्य निशान',
    mr: 'इतर डाग/ इतर चट्टे',
    te: 'ఇతర మచ్చలు',
    kn: 'ಇತರ ಗುರುತುಗಳು',
    ta: 'பிற வடுக்கள்',
    bn: 'অন্য ক্ষতচিহ্ন',
    ml: 'മറ്റ് പാടുകൾ',
  },
  {
    en: 'Puffy Eyes',
    hi: 'सूजी हुई आँखें',
    mr: 'सुजलेले डोळे',
    te: 'ఉబ్బెత్తు కళ్ళు',
    kn: 'ಪಫಿ ಐಸ್',
    ta: 'வீக்கமான கண்கள்',
    bn: 'ফোলা চোখ',
    ml: 'വീർത്ത കണ്ണുകൾ',
  },
  {
    en: 'Perioral Pigmentation',
    hi: 'पेरिओरल पिगमेंटेशन',
    mr: 'पेरिओरल पिगमेंटेशन',
    te: 'పెరియోరల్ పిగ్మెంటేషన్',
    kn: 'ಪೆರಿಯೊರಲ್ ಪಿಗ್ಮೆಂಟೇಶನ್',
    ta: 'பீரியோரல் பிக்மென்டேஷன்',
    bn: 'পেরিওরাল পিগমেন্টেশন',
    ml: 'മുഖത്തിന് ചുറ്റുമുള്ള ചർമ്മത്തിന്റെ നിറം മങ്ങൽ',
  },
  {
    en: 'Freckles',
    hi: 'झाइयाँ',
    mr: 'डाग',
    te: 'మచ్చలు',
    kn: 'ನಸುಕಂದು ಮಚ್ಚೆಗಳು',
    ta: 'முகப்புள்ளிகள்',
    bn: 'ফ্রেকলস',
    ml: 'പുള്ളികൾ',
  },
  {
    en: 'Facial Hair',
    hi: 'चेहरे पर बाल',
    mr: 'चेहऱ्यावरील केस',
    te: 'ముఖం పై వెంట్రుకలు',
    kn: 'ಮುಖದ ಕೂದಲು',
    ta: 'முகத்தில் முடி வளர்ச்சி',
    bn: 'মুখের লোম',
    ml: 'മുഖത്തിലെ രോമം',
  },
  {
    en: 'Nodules',
    hi: 'नोड्यूल',
    mr: 'नोड्यूल',
    te: 'నాడ్యూల్',
    kn: 'ನಾಡ್ಯೂಲ್',
    ta: null,
    bn: null,
    ml: null,
  },
  {
    en: 'Cystic',
    hi: 'सिस्ट',
    mr: 'सिस्ट',
    te: 'సిస్ట్',
    kn: 'ಸಿಸ್ಟ್',
    ta: null,
    bn: null,
    ml: null,
  },
  {
    en: 'Blackheads',
    hi: 'ब्लैकहेड्स',
    mr: 'ब्लॅकहेड्स',
    te: 'బ్లాక్‌హెడ్స్',
    kn: 'ಬ್ಲ್ಯಾಕ್‌ಹೆಡ್ಸ್',
    ta: null,
    bn: null,
    ml: null,
  },
];
